import axios from '@/config/axiosInterceptor'
import { BASE_URLS, ENVIRONMENT_MODE } from '@/config/constants'

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_TASK_URL

export const switchLocation = (hotel_id: string) => {
  return axios.put(`${baseURL}switchLocation/${hotel_id}`)
}
